import { Typography,Box } from "@mui/material";
import { useState,useEffect, Fragment } from "react";
import CoursesBlog from "../../../../Blog/courses-blog.component";
import {getIasDataMenu} from "../../../../../utils/firebase/firebase.utils";
import { Helmet } from "react-helmet-async";

const IasMenu = ()=>{

    const [courseData,setCourseData] = useState([]);

    useEffect(()=>{
        const getData = async()=>{
            const arrayData = await getIasDataMenu();
            const{data} = arrayData;
            setCourseData(data.reverse());
        
        }

        getData();
        
        
    },[])




    return(
        <Fragment>
            <Helmet prioritizeSeoTags>
                <title>Ias Study Material Economy : Prelims and Mains Study Plan</title>
                <meta name="description" content="Get daily study material and mock test on IAS to crack IAS Prelims and Mains exam . " />        
                <link rel="canonical" href="https://www.ahguide.in/ias-study-material" />
            </Helmet>
        <Box>
            
            <Typography sx={{textAlign:"center",marginTop:'20px'}} variant="h3" component="div">
                IAS
            </Typography>
            {
                courseData.map((data)=>{
                    return  <CoursesBlog key={data.title} courseData= {data}  />
                })
            }

        </Box>
        </Fragment>
    )

}

export default IasMenu;